import { UpaTarget } from './../../services/upa.service';
import { Component, EventEmitter, Injector, Input, Output, ViewEncapsulation } from '@angular/core';
import { AbstractComponent } from '../abstract.component';
import { ButtonOptions } from '../eva-button/eva-button.component';

@Component({
  selector: 'eva-message',
  template: `
    <div *ngIf="data" class="eva-3-message {{data.message_type}}"
         [ngClass]="{'-border': data.border, '-no-title': !data.title}">
      <div class="message-icon-container">
        <i class="message-icon eva-3-icon-{{data.icon}}"></i>
      </div>
      <div *ngIf="data.title" class="message-header">
        <h5 class="eva-3-h5 message-title">{{data.title | translate: data.title_params || {} }}</h5>
        <i *ngIf="data.showCloseIcon" class="message-close eva-3-icon-cross -eva-3-icon-xsm" (click)="onCloseClick()"></i>
        <button *ngIf="data.showEditButton" class="message-edit-button eva-3-btn -sm -link" name="" (click)="onEditClick()">
          <em class="message-edit-button-text">{{ 'evaMessage.editButton' | translate }}</em>
        </button>
      </div>
      <div *ngIf="data.text" class="message-body">
        <p class="eva-3-p message-text" [innerHTML]="(data.text | translate: data.text_params || {}) | replaceKeywords: keywordsMap"></p>
        <div *ngIf="data.link_options || data.button_options" class="message-action">
          <eva-button *ngIf="data.button_options" [options]="data.button_options" [moduleId]="getModuleId()" [moduleIndex]="moduleIndex" [uniqueId]="uniqueId"></eva-button>
          <a *ngIf="data.link_options" class="eva-3-link message-link" [href]="data.link_options.link" (click)="clickHandler($event)">
            {{data.link_options.link_text | translate}}
          </a>
        </div>
      </div>
    </div>
  `,
  styleUrls: ['./eva-message.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EvaMessageComponent extends AbstractComponent {
  private static MODULE_ID: string = 'EvaMessageModule';

  @Input() data: EvaMessageOptions;
  @Input() uniqueId?: string;
  @Input() moduleIndex: number;
  // TODO: cambiar el close por un output con otro nombre
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() close = new EventEmitter<void>();
  @Output() edit = new EventEmitter<void>();

  constructor(injector: Injector) {
    super(injector);
  }

  getModuleId() {
    return EvaMessageComponent.MODULE_ID;
  }

  clickHandler(event) {
    if (this.data.link_options != null && this.data.link_options.link != null) {
      this.upaService.trackClickTopic({
        label: this.data.link_options.link_text,
        moduleId: this.getModuleId(),
        uniqueId: this.uniqueId,
        moduleIndex: this.moduleIndex,
        target: UpaTarget.BUTTON,
        href: this.data.link_options.link
      }, event);
    }
  }

  onCloseClick() {
    this.close.emit();
  }

  onEditClick() {
    this.edit.emit();
  }
}

export interface EvaMessageOptions {
  message_type: string;
  text?: string;
  text_params?: Record<string, string>;
  icon?: string;
  title?: string;
  title_params?: Record<string, string>;
  border?: boolean;
  button_options?: ButtonOptions;
  link_options?: LinkOptions;
  showCloseIcon?: boolean;
  showEditButton?: boolean;
}

export interface LinkOptions {
  link: string;
  link_text: string;
}
